import { render, staticRenderFns } from "./HeartRateChart.vue?vue&type=template&id=31f989bc&scoped=true&"
import script from "./HeartRateChart.vue?vue&type=script&lang=js&"
export * from "./HeartRateChart.vue?vue&type=script&lang=js&"
import style0 from "./HeartRateChart.vue?vue&type=style&index=0&id=31f989bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f989bc",
  null
  
)

export default component.exports